import { render, staticRenderFns } from "./AclaimsProcess.vue?vue&type=template&id=cfdadaca&scoped=true"
import script from "./AclaimsProcess.vue?vue&type=script&lang=js"
export * from "./AclaimsProcess.vue?vue&type=script&lang=js"
import style0 from "./AclaimsProcess.vue?vue&type=style&index=0&id=cfdadaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdadaca",
  null
  
)

export default component.exports